import { ContextMenu } from '../../../../Basic/Elements';

const MarketContextMenu = ({
  market,
  onDelete = () => { },
  changeMarginality = () => { },
  UnarchiveProducts = () => _,
  archiveProducts = () => _,
  stopbrandProducts = () => _,
  UnstopbrandProducts = () => _,
  isArchive = false,
  isStopbrand = false,
  updateStocks = (_) => _, // флаг = true - занулить остатки, false - просто обновнить
  updatePrices = (_) => _,
  toBasket = () => { }, // флаг = true - добавить в корзину, false - достать
  updateImages = () => { },
  isBasket = false,
}) => {
  return (
    <>
      <ContextMenu
        list={[
          {
            text: 'Перенести в архив',
            callback: () => archiveProducts(),
            isHidden: isArchive || isStopbrand || market !== 'OZON',
          },
          { text: 'Убрать с архива', callback: () => UnarchiveProducts(), isHidden: !isArchive || market !== 'OZON' },
          { text: 'Перенести в стоп бренды', callback: () => stopbrandProducts(), isHidden: isArchive || isStopbrand },
          { text: 'Убрать с стоп брендов', callback: () => UnstopbrandProducts(), isHidden: !isStopbrand },
          { text: 'Обновить остатки', callback: () => updateStocks() },
          { text: 'Обнулить остатки', callback: () => updateStocks(true) },
          { text: 'Пересчитать цены', callback: () => updatePrices() },
          { text: 'Перенести в корзину', callback: () => toBasket(true), isHidden: market !== 'WB' || isBasket },
          { text: 'Достать с корзины', callback: () => toBasket(false), isHidden: market !== 'WB' || !isBasket },
          { text: 'Обновить фото ИИ', callback: () => updateImages(), isHidden: market !== 'WB' || isBasket },

          /*  { text: 'Поменять маржинальность', callback: changeMarginality, isHidden: isArchive },*/
          { text: 'Удалить товары', callback: () => onDelete(), isHidden: market !== 'MM' },
        ]}
      >
        Действия
      </ContextMenu>
    </>
  );
};

export default MarketContextMenu;
